import { addDays, format, parseISO } from 'date-fns';
import type { AvailabilityStatus } from '@/lib/types';

export function buildAvailabilityRange(
  startDate: string,
  endDate: string,
  status: AvailabilityStatus
): { date: string; status: AvailabilityStatus }[] {
  const updates: { date: string; status: AvailabilityStatus }[] = [];
  let current = parseISO(startDate);
  const end = parseISO(endDate);

  while (current <= end) {
    updates.push({ date: format(current, 'yyyy-MM-dd'), status });
    current = addDays(current, 1);
  }

  return updates;
}
